const PASSBACK_PROBE_TIMES_MS = [250, 500, 1000, 2000, 4000, 8000, 12000];
const PASSBACK_FINAL_COLLAPSE_MS = 15000;

function clearVidvertoPassbackWatch(wrapper) {
  if (!wrapper) return;

  if (wrapper.__cleonVidvertoPassbackObserver) {
    try { wrapper.__cleonVidvertoPassbackObserver.disconnect(); } catch {}
    wrapper.__cleonVidvertoPassbackObserver = null;
  }

  if (Array.isArray(wrapper.__cleonVidvertoPassbackTimers)) {
    wrapper.__cleonVidvertoPassbackTimers.forEach((timer) => clearTimeout(timer));
  }

  wrapper.__cleonVidvertoPassbackTimers = [];
}

function rememberWrapperSize(wrapper) {
  if (!wrapper || wrapper.__cleonPassbackOriginalStyle) return;

  wrapper.__cleonPassbackOriginalStyle = {
    display: wrapper.style.display || "",
    visibility: wrapper.style.visibility || "",
    opacity: wrapper.style.opacity || "",
    width: wrapper.style.width || "",
    maxWidth: wrapper.style.maxWidth || "",
    minHeight: wrapper.style.minHeight || "",
    height: wrapper.style.height || "",
    overflow: wrapper.style.overflow || "",
    margin: wrapper.style.margin || "",
    padding: wrapper.style.padding || "",
  };
}

function collapseWrapper(wrapper) {
  if (!wrapper) return;

  wrapper.setAttribute("data-cleon-passback-empty", "1");

  wrapper.style.setProperty("height", "0px", "important");
  wrapper.style.setProperty("min-height", "0px", "important");
  wrapper.style.setProperty("max-height", "0px", "important");
  wrapper.style.setProperty("overflow", "hidden", "important");
  wrapper.style.setProperty("margin", "0px", "important");
  wrapper.style.setProperty("padding", "0px", "important");
  wrapper.style.setProperty("opacity", "0", "important");
  wrapper.style.setProperty("visibility", "hidden", "important");
  wrapper.style.setProperty("pointer-events", "none", "important");

  const anchor = wrapper.previousElementSibling;
  if (anchor?.classList?.contains("cleon-inline-anchor")) {
    anchor.style.setProperty("height", "0px", "important");
  }
}

function isVisibleElement(el, { allowHiddenProbe = false } = {}) {
  if (!el || !el.isConnected) return false;

  if (el.closest(".aries_proscenium.aries_collapsed")) {
    return false;
  }

  const style = window.getComputedStyle(el);
  const rect = el.getBoundingClientRect();

  if (style.display === "none") return false;

  if (!allowHiddenProbe) {
    if (style.visibility === "hidden") return false;
    if (Number(style.opacity || 1) <= 0) return false;
  }

  return rect.width > 1 && rect.height > 1;
}

function hasVisibleVidvertoSurface(wrapper) {
  if (!wrapper) return false;

  const visibleIframe = [...wrapper.querySelectorAll("iframe")].some((iframe) =>
    isVisibleElement(iframe, { allowHiddenProbe: true })
  );
  if (visibleIframe) return true;

  const visibleVideo = [...wrapper.querySelectorAll("video")].some((video) => {
    if (!isVisibleElement(video, { allowHiddenProbe: true })) return false;

    const rect = video.getBoundingClientRect();

    return (
      rect.width > 1 &&
      rect.height > 1 &&
      video.readyState > 0
    );
  });

  return visibleVideo;
}

function hasVidvertoShell(wrapper) {
  if (!wrapper) return false;

  return !!wrapper.querySelector(
    ".aries_div, [id^='aries_div_'], .aries_stage, .aries_proscenium"
  );
}

function hasVidvertoPayload(wrapper) {
  if (!wrapper) return false;

  return !!wrapper.querySelector("iframe, video, object, embed, canvas");
}

function hasVidvertoMounted(wrapper) {
  return hasVidvertoShell(wrapper);
}

function isVidvertoCollapsed(wrapper) {
  if (!hasVidvertoMounted(wrapper)) return false;

  return !!wrapper.querySelector(".aries_proscenium.aries_collapsed");
}

function syncVidvertoPassbackSize(wrapper, options = {}) {
  if (!wrapper) return;

  const { forceTimeoutCollapse = false } = options;

  const mounted = hasVidvertoMounted(wrapper);
  const collapsed = isVidvertoCollapsed(wrapper);
  const hasVisibleSurface = hasVisibleVidvertoSurface(wrapper);
  const hasPayload = hasVidvertoPayload(wrapper);

  if (collapsed) {
    collapseWrapper(wrapper);
    wrapper.setAttribute("data-cleon-passback-state", "vidverto-collapsed");
  } else if (hasVisibleSurface) {
    openWrapperForVidverto(wrapper);
    wrapper.setAttribute("data-cleon-passback-state", "filled");
  } else if (hasPayload) {
    openWrapperForVidverto(wrapper);
    wrapper.setAttribute("data-cleon-passback-state", "mounted-real-payload");
  } else if (forceTimeoutCollapse) {
    collapseWrapper(wrapper);
    wrapper.setAttribute(
      "data-cleon-passback-state",
      mounted ? "timeout-shell-only" : "timeout-empty"
    );
  } else if (mounted) {
    openWrapperForVidverto(wrapper);
    wrapper.setAttribute("data-cleon-passback-state", "waiting-shell");
  } else {
    openWrapperForVidverto(wrapper);
    wrapper.setAttribute("data-cleon-passback-state", "waiting");
  }
}

function watchVidvertoPassback(wrapper) {
  if (!wrapper || wrapper.__cleonVidvertoPassbackObserver) return;

  let raf = null;
  let done = false;

  const addTimer = (callback, delay) => {
    const timer = setTimeout(callback, delay);
    wrapper.__cleonVidvertoPassbackTimers ||= [];
    wrapper.__cleonVidvertoPassbackTimers.push(timer);
    return timer;
  };

  const run = (options = {}) => {
    if (done) return;
    if (raf) cancelAnimationFrame(raf);

    raf = requestAnimationFrame(() => {
      raf = null;

      syncVidvertoPassbackSize(wrapper, options);

      const state = wrapper.getAttribute("data-cleon-passback-state");

      if (
        state === "vidverto-collapsed" ||
        state === "timeout-empty" ||
        state === "timeout-shell-only"
      ) {
        done = true;

        if (wrapper.__cleonVidvertoPassbackObserver) {
          wrapper.__cleonVidvertoPassbackObserver.disconnect();
          wrapper.__cleonVidvertoPassbackObserver = null;
        }

        if (Array.isArray(wrapper.__cleonVidvertoPassbackTimers)) {
          wrapper.__cleonVidvertoPassbackTimers.forEach((timer) => clearTimeout(timer));
          wrapper.__cleonVidvertoPassbackTimers = [];
        }
      }
    });
  };

  const observer = new MutationObserver(() => run());

  observer.observe(wrapper, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style", "hidden"],
  });

  wrapper.__cleonVidvertoPassbackObserver = observer;

  run();

  PASSBACK_PROBE_TIMES_MS.forEach((delay) => {
    addTimer(() => run(), delay);
  });

  addTimer(() => run({ forceTimeoutCollapse: true }), PASSBACK_FINAL_COLLAPSE_MS);
}

function openWrapperForVidverto(wrapper) {
  if (!wrapper) return;

  wrapper.hidden = false;
  wrapper.removeAttribute?.("hidden");
  wrapper.classList?.remove("ad-slot--pending");
  wrapper.removeAttribute("data-cleon-passback-empty");

  wrapper.style.setProperty("display", "block", "important");
  wrapper.style.setProperty("visibility", "visible", "important");
  wrapper.style.setProperty("opacity", "1", "important");
  wrapper.style.setProperty("pointer-events", "auto", "important");

  wrapper.style.setProperty("width", "720px", "important");
  wrapper.style.setProperty("max-width", "100%", "important");

  // Give a sane minimum, but do not trap Vidverto if it resizes itself.
  wrapper.style.setProperty("min-height", "90px", "important");
  wrapper.style.removeProperty("height");
  wrapper.style.removeProperty("max-height");
  wrapper.style.removeProperty("overflow");

  wrapper.style.removeProperty("margin");
  wrapper.style.removeProperty("padding");

  wrapper.style.removeProperty("position");
  wrapper.style.removeProperty("left");
  wrapper.style.removeProperty("top");

  const anchor = wrapper.previousElementSibling;
  if (anchor?.classList?.contains("cleon-inline-anchor")) {
    anchor.style.removeProperty("height");
    anchor.style.setProperty("height", "1px");
  }
}

function openWrapperForMountedVidverto(wrapper) {
  if (!wrapper) return;

  wrapper.hidden = false;
  wrapper.removeAttribute?.("hidden");
  wrapper.classList?.remove("ad-slot--pending");
  wrapper.removeAttribute("data-cleon-passback-empty");

  wrapper.style.setProperty("display", "block", "important");
  wrapper.style.setProperty("visibility", "visible", "important");
  wrapper.style.setProperty("opacity", "1", "important");
  wrapper.style.setProperty("pointer-events", "auto", "important");

  wrapper.style.setProperty("width", "720px", "important");
  wrapper.style.setProperty("max-width", "100%", "important");

  // Once Vidverto mounted, stop forcing our 405px shell.
  // Let Vidverto's own DOM determine height.
  wrapper.style.removeProperty("height");
  wrapper.style.removeProperty("min-height");
  wrapper.style.removeProperty("max-height");
  wrapper.style.removeProperty("overflow");

  wrapper.style.removeProperty("margin");
  wrapper.style.removeProperty("padding");

  wrapper.style.removeProperty("position");
  wrapper.style.removeProperty("left");
  wrapper.style.removeProperty("top");

  const anchor = wrapper.previousElementSibling;
  if (anchor?.classList?.contains("cleon-inline-anchor")) {
    anchor.style.removeProperty("height");
    anchor.style.setProperty("height", "1px");
  }
}

export function loadVidvertoFromSnippet(wrapper, rawSnippet) {
  if (!wrapper || !rawSnippet) return;

  clearVidvertoPassbackWatch(wrapper);
  wrapper.classList?.remove("ad-slot--pending");
  wrapper.innerHTML = "";

  rememberWrapperSize(wrapper);

  openWrapperForVidverto(wrapper);

  const idMatch = rawSnippet.match(/<script[^>]*id=["']([^"']+)["']/i);
  const scriptId = idMatch ? idMatch[1] : `_vidverto_${Date.now()}`;

  const codeMatch = rawSnippet.match(/<script[^>]*>([\s\S]*?)<\/script>/i);
  let innerCode = codeMatch ? codeMatch[1].trim() : rawSnippet.trim();

  innerCode = innerCode
    .replace(/\\"/g, '"')
    .replace(/\\'/g, "'")
    .replace(/\\\\/g, "\\");

  const existing = document.getElementById(scriptId);
  if (existing) existing.remove();

  const script = document.createElement("script");
  script.id = scriptId;

  script.text = `
  try {
  ${innerCode}
  } catch (e) {}
  `;

  wrapper.appendChild(script);

  watchVidvertoPassback(wrapper);
}